<template>
  <router-view />
</template>
<script>
export default { name: 'Webhooks' }
</script>
